import { createSlice } from "@reduxjs/toolkit";

const sessionSlice = createSlice({
  name: "session",
  initialState: { showPopup: false },
  reducers: {
    showSessionTimeoutPopup: (state) => {
      state.showPopup = true;
    },
    hideSessionTimeoutPopup: (state) => {
      state.showPopup = false;
    },
  },
});

export const { showSessionTimeoutPopup, hideSessionTimeoutPopup } =
  sessionSlice.actions;
export default sessionSlice.reducer;
